import {zonedDateKey as displayDateKey} from '../shared/display-timezone.js';
import React,{useState} from 'react';
import {Button} from './delivered/components/primitives';
import {CalendarPicker} from './delivered/components/CalendarPicker';
import {selectRangeDate} from '../shared/date-range-selection.js';

export function RouteRangePicker({start,end,onApply,locale='da-DK',disabled=false}:{start:string;end:string;onApply:(start:string,end:string)=>void;locale?:string;disabled?:boolean;color?:string;surface?:string}){
 const [open,setOpen]=useState(false),[anchor,setAnchor]=useState<string|null>(null),[error,setError]=useState('');
 const da=locale==='da-DK';
 const choose=(day:string)=>{
  const next=selectRangeDate(anchor,day,displayDateKey());
  if(next.error){setError(da?'Vælg højst 31 dage ad gangen.':'Choose up to 31 days at a time.');return;}
  setError('');setAnchor(next.anchor);
  if(next.start&&next.end){onApply(next.start,next.end);setOpen(false);}
 };
 return <><Button label={da?'Vælg dato':'Choose date'} icon="calendar" tone="secondary" disabled={disabled} onPress={()=>{setAnchor(null);setError('');setOpen(true);}}/>{open&&<CalendarPicker value={anchor??start} rangeEnd={anchor?undefined:end} locale={da?'da-DK':'en-GB'} instruction={anchor?(da?'Vælg slutdato. Tryk samme dato igen for én dag.':'Choose the end date. Tap the same date again for one day.'):(da?'Vælg startdato.':'Choose the start date.')} error={error} onClose={()=>setOpen(false)} onSelect={choose}/>}</>;
}
